module.exports = __webpack_public_path__ + "static/media/Once Upon a Time_front cover.058aed0f.jpg";